// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3003f389","453":"0737e0b0","578":"afd0bead","622":"a31c7aef","857":"b54484ef","977":"1d08feda"}[chunkId] + ".chunk.js";
};